// Human-readable labels for Pennylane transmission reasons (codes returned by the backend)
export const pennylaneReasonLabel = (t, code) => {
    if(!code) return ''
    const label = t(code)
    return (label && label !== code) ? label : code
}

// Last error: either a coded reason or a raw API message
export const pennylaneErrorLabel = (t, error) => {
    if(!error) return ''
    if(error.code) return pennylaneReasonLabel(t, error.code)
    return error.message ?? ''
}

const PENNYLANE_IN_PROGRESS_STATUSES = ['pending','pdf_ready','importing','import_unknown','retry_wait','waiting_origin','awaiting_conversion']
const PENNYLANE_FAILED_STATUSES = ['blocked','validation_error','error']

// Icon colour for a transmission status, at a glance in a list: green = transmitted, orange =
// something is missing or failed, blue = in progress, default = never requested
export const pennylaneStatusColorClass = (status) => {
    if(!status) return 'text-primary'
    if(status==='imported') return 'text-success'
    if(PENNYLANE_FAILED_STATUSES.includes(status)) return 'text-warning'
    if(PENNYLANE_IN_PROGRESS_STATUSES.includes(status)) return 'text-info'
    return 'text-primary'
}
